import type { ReactNode, SVGProps } from "react";
export function AddBeneficiaryIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 11 14"
			width="11"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.7666 3.1001C1.7666 3.76314 2.01243 4.39902 2.45002 4.86786C2.8876 5.33671 3.4811 5.6001 4.09993 5.6001C4.71877 5.6001 5.31227 5.33671 5.74985 4.86786C6.18744 4.39902 6.43327 3.76314 6.43327 3.1001C6.43327 2.43706 6.18744 1.80117 5.74985 1.33233C5.31227 0.86349 4.71877 0.600098 4.09993 0.600098C3.4811 0.600098 2.8876 0.86349 2.45002 1.33233C2.01243 1.80117 1.7666 2.43706 1.7666 3.1001Z"
				stroke="#131316"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M6.43359 10.6001H9.93359"
				stroke="#131316"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M8.18359 8.7251V12.4751"
				stroke="#131316"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.600098 11.8501V10.6001C0.600098 9.93706 0.84593 9.30117 1.28352 8.83233C1.7211 8.36349 2.31459 8.1001 2.93343 8.1001H5.26676"
				stroke="#131316"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
